export enum AccountTypeName {
  FREE_ACCOUNT = 'フリーアカウント',
  BASIC = 'ベーシック',
  STANDARD = 'スタンダード',
  PREMIUM = 'プレミアム'
}
